import { booleanAttribute, Component, EventEmitter, inject, input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { MuiI18nProvider } from '../../i18n';


@Component({
  selector: 'mui-modal-header',
  templateUrl: './mui-modal-header.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `
  ],
  host: {
    class: 'mui-modal__header'
  }
})
export class MuiModalHeader {
  readonly title = input<string>();
  readonly titleId = input<string>();
  readonly closeButtonLabel = input<string>();
  readonly hideCloseButton = input(false, { transform: booleanAttribute });

  @Output() dismiss = new EventEmitter<void>();

  protected readonly modal = inject(NgbActiveModal, { optional: true });
  protected readonly translations$: Observable<{ basicConfirmButton: string; basicDismissButton: string; closeButton: string }>;
  private _i18n: MuiI18nProvider;

  constructor() {
    this._i18n = inject(MuiI18nProvider);
    this.translations$ = this._i18n.modal();
  }

  protected onDismiss(): void {
    if (this.modal) {
      this.modal.dismiss('X');
    }

    this.dismiss.emit();
  }
}
